const condo_sec2Object = payload => {
  return {
    type: "condosec2",
    payload
  };
};

export default condo_sec2Object;
